export function SvgUri({ uri, ...props }: { uri: string }) {
  return <img src={uri} {...props} />;
}
